import {Placeholder as _Placeholder} from '../../../placeholder'
import {useFilterContext} from '../../../filters/context'
import {FiltersPlaceholder} from '../../../filters/components'
import {useBasicTableContext} from '../../context'

const layoutProps = {width: 'full', height: 'unset', margin: '48px 0 0 0'}

export const Placeholder = () => {
	const {hasData, placeholderProps} = useBasicTableContext()
	const {hasFiltered} = useFilterContext()

	if (hasData) return null

	if (hasFiltered) return <FiltersPlaceholder layoutProps={layoutProps} />

	if (placeholderProps) return <_Placeholder layoutProps={layoutProps} {...placeholderProps} />

	return <_Placeholder layoutProps={layoutProps} name="no_data" subtitle={false} animation="desert" />
}
